import ServiceCard from "@/components/ui/service-card";
import SectionHeading from "@/components/ui/section-heading";
import { House, Building, Factory } from "lucide-react";

const services = [
    {
        icon: <House />,
        title: "Residential Property Owners Insurance",
        description: "Cover for let, unoccupied and HMO properties - including DSS and asylum seeker tenants.",
        link: "/services#residentialpropertyowners"
    },
    {
        icon: <Building />,
        title: "Commercial Property Owners Insurance",
        description: "Flexible cover for let and unoccupied commercial buildings - including mixed-use.",
        link: "/services#commercialpropertyowners"
    },
    {
        icon: <Factory />,
        title: "Commercial Combined Insurance",
        description: "Tailored business cover across a range of sectors, all in one comprehensive policy.",
        link: "/services#commercialcombined"
    }
];

const ServiceCards = () => {
    return (
        <section id="services" className="bg-sky-50 py-8 ">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <SectionHeading
                    title="Our Insurance Services"
                    description="We offer a wide range of insurance solutions designed to protect what matters most to your clients."
                    center
                />

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {services.map((service, index) => (
                        <ServiceCard
                            key={index}
                            icon={service.icon}
                            title={service.title}
                            description={service.description}
                            link={service.link}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceCards;
